module.exports = __webpack_public_path__ + "static/media/4k_website_logo_sup_hkbs.2ea2ba89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/4k_website_logo_sup_hkbs.jpg
// module id = 64
// module chunks = 0